import { API_HOST } from "~/config";
import { getAuthHeader } from "./getAuthHeader";
import { AssetType } from "~/types/AssetType";

const contentTypeHeader = { "Content-Type": "application/json" };
const getHeaders = () => ({ ...contentTypeHeader, ...getAuthHeader() });

// TODO: import dto from be
export type AsyncProcessType = "upload" | "optimise";

export type AsyncProcessStatus = "in_progress" | "success" | "failed";

export type AsyncProcess = {
  id: string;
  startedByUserId?: string;
  type: AsyncProcessType;
  name: string;
  assetType: AssetType;
  status: AsyncProcessStatus;
  fileSize?: number;
};

export const getAsyncProcesses = async (sceneId: string) => {
  const requestOptions = {
    method: "GET",
    headers: getHeaders(),
  };

  const response = await fetch(`${API_HOST}/async-processes/${sceneId}`, requestOptions);
  const status = response.status;
  const responseBody = await response.json();
  return { status, body: responseBody as AsyncProcess[] };
};
